import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesPacking } from '@fortawesome/pro-solid-svg-icons';
import PropertyRecordRow from './property_record_row';
import EmptyState from '../empty_state';
import type { PropertyRecord } from 'bundles/connect/types';

type Props = {
  records: PropertyRecord[];
}

export default function PropertyRecords({ records }: Props) {
  if (records.length === 0) {
    return (
      <EmptyState
        icon={faBoxesPacking}
        title="No Property Records Found"
      />
    );
  }
  
  return (
    <div className="d-flex flex-column gap-3">
      <div className="d-flex align-items-center gap-2">
        <FontAwesomeIcon className="text-secondary" icon={faBoxesPacking} />
        <h6 className="my-0 fw-bolder">Property Records</h6>
      </div>
      <div className="d-flex flex-column">
        {records.map((record, idx) => (
          <PropertyRecordRow collapsed={idx === 0 ? false : true} key={idx} propertyRecord={record} />
        ))}
      </div>
    </div>
  );
}
